<template>
  <b-col
    cols="12"
    sm="6"
  >
    <b-row class="text-muted font-w500 font-size-sm">
      <b-col class="d-flex align-items-center">
        <b-link :href="getLinkHref(value.category, value.content)">
          {{ value.content }}
        </b-link>
      </b-col>

      <b-col cols="auto p-0">
        <b-dropdown
          variant="link"
          size="sm"
          no-caret
          right
        >
          <template #button-content>
            <i class="fa fa-ellipsis-v" />
          </template>
          <b-dropdown-item
            v-if="$can('update', referenceType)"
            v-b-modal="`contact-info-${value.id}-edit-modal`"
          >
            <i class="fa fa-fw fa-pencil-alt" />
            Edit
          </b-dropdown-item>
          <b-dropdown-item
            v-if="$can('update', referenceType)"
            @click="destroyContactInfoDialog(value.id)"
          >
            <i class="fa fa-fw fa-times" /> Delete
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col>
        {{ value.category | humanizedFormat | capitalizeFormat }}
      </b-col>
    </b-row>

    <edit-modal
      v-if="$can('update', referenceType)"
      :value="value"
      @on-save="(updatedContactInfo) => $emit('on-save', updatedContactInfo)"
    />
  </b-col>
</template>

<script>
import EditModal from '@/components/admin/contactInfos/EditModal.vue';
import { DateTime } from 'luxon';

export default {
  name: 'ContactInfosCardItem',
  components: {
    EditModal,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    referenceType: {
      type: String,
      required: true,
    },
  },
  methods: {
    getLinkHref(category, content) {
      const linkMap = {
        email: 'mailto',
        billing_email: 'mailto',
        phone: 'tel',
        billing_phone: 'tel',
        fax: 'fax',
      };
      return `${linkMap[category] || '#'}:${content}`;
    },
    destroyContactInfoDialog(id) {
      this.$swal({
        text: 'Once it\'s deleted, its gone forever!',
        preConfirm: () => this.$contactInfosAPI.update(id, { deleted_at: DateTime.now().toISODate() }),
      }).then((result) => {
        if (result.value) {
          this.$emit('on-destroy');
        }
        result.timer;
      });
    },
  },
};
</script>
